import { CurrentTeamGq } from '../../graphql/users/models/CurrentTeamGq';

export function useRankCapacityCheck(
  team: CurrentTeamGq,
  keywordCount: number,
  domainSpecific?: boolean
) {
  let cost = keywordCount * 1;
  if (domainSpecific) cost = cost * 5;

  const limitOk =
    (team?.activeSubscriptionPeriod?.monthlyUseRankKw ?? 0) + cost <=
    (team?.activeSubscriptionPeriod?.monthlyCapRankKw ?? 0);

  return {
    rankSelectionOk: limitOk,
  };
}
